import React from "react";
import { Avatar, FormControl, Switch } from "@mui/material";
import styled from "@emotion/styled";

export const FormContainer: React.FC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30%;
`;

export const FormComponentContainer = styled.div`
  margin-bottom: 20px;
`;

export const StyledAvatar = styled(Avatar)(() => {
  return {
    marginBottom: "20px",
    backgroundColor: "rgb(245, 0, 87)",
  };
});

export const StyledInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const StyledFormControl = styled(FormControl)`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const StyledLabel = styled.label`
  display: block;
  width: 100%;
`;

export const Footer = styled.div`
  max-width: 200px;
  margin: auto;
`;

export const StyledSwitch = styled(Switch)``;
